
import { useNavigate } from "react-router-dom";
import { Box, Grid, IconButton, Typography } from "@mui/material";
import { iconos } from "../../data";







export const LayoutReturn = ({ children, titulo = 'No hay Datos', url, admin=true }) => {


    const navigate = useNavigate();


    const handleReturn = () => {
        if(!isNaN(url)) {
            navigate(url * -1)
        }else {
            navigate(`${url}`)
        }
    }


    return (

        <>
            {(admin) &&
            <Grid container direccion='row' alignItems='center'>

                <IconButton onClick={ handleReturn } 
                    sx={{ color:'#fff', backgroundColor:'secondary.main', ':hover': {backgroundColor:'secondary.main', opacity:0.3 }}}
                >
                    {iconos['back']}
                </IconButton>

                <Box flex={ 1 } />
                <Typography variant='h2'>{ titulo }</Typography>
                <Box flex={ 1 } />

                <Box sx={{width:30}} />
            </Grid>
            }

            <Grid container alignItems='center' justifyContent='center' >
                { children }
            </Grid>
        </>
    )
}
